import { createApp } from 'vue'
import appSearch from './app.vue';

export default () => {
  createApp(appSearch).mount("vue-global-search")
}